import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    CHANGE_CUSTOMER_RISK_LEVELS,
    CHANGE_TX_RISK_LEVELS,
    DEFAULTS,
    gaEventWithUserIdLabel,
    gaPageView,
    izEmpty,
    izNotBlank,
    izNotEmpty,
    LOG_OUT
} from "../constants";
import {UserAction} from "../actions/UserAction";
import {DatePicker, message, Select, Spin} from "antd";
import TransactionService from "../services/transaction.service";
import CustomerService from "../services/customer.service";
import i18n from "i18next";
import AuthService from "../services/auth.service";
import moment from "moment";
import localeTR from 'antd/es/date-picker/locale/tr_TR';
import localeEN from 'antd/es/date-picker/locale/en_GB';
import Search from "antd/es/input/Search";
import {LoadingOutlined} from "@ant-design/icons";
import CommonService from "../services/common.service";
import {CommonAction} from "../actions/CommonAction";
import TransactionTable from "./TransactionTable";

const {Option} = Select;
const {RangePicker} = DatePicker;
const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;

class TransactionMonitoring extends Component {

    componentDidMount() {
        gaPageView()
        this.checkTxRiskLevels();
        this.checkCustomerRiskLevels();
        this.search()
    }

    constructor(props) {
        super(props)

        const txRiskLevels = this.props.common.txRiskLevels
        const customerRiskLevels = this.props.common.customerRiskLevels

        this.state = {
            riskLevel: 'all',
            txRiskLevels: txRiskLevels,
            txLevelColors: DEFAULTS.txLevelColors,
            customerRiskLevels: customerRiskLevels,
            dateType: 'last_7_days',
            filterCriteria: '',
            searching: true,
            startDate: '',
            endDate: '',
            items: [],
        }
    }

    getTxRiskLevel(riskLevel) {
        const txRiskLevels = this.props.common.txRiskLevels

        if (izEmpty(txRiskLevels) || this.izNotTxRiskLevelExist(riskLevel)) return {name: riskLevel, order: 11};

        return txRiskLevels.filter(txRiskLevel => txRiskLevel.code === riskLevel)[0];
    }

    getTxRiskLevelName(riskLevel) {
        return this.getTxRiskLevel(riskLevel).name
    }

    getTxRiskLevelOrder(riskLevel) {
        return this.getTxRiskLevel(riskLevel).order
    }

    getTxRiskLevelColor(txRiskLevel) {

        const order = this.getTxRiskLevelOrder(txRiskLevel);

        return DEFAULTS.txLevelColors[order];
    }

    checkTxRiskLevels = () => {

        const txRiskLevels = this.state.txRiskLevels
        if (izNotEmpty(txRiskLevels)) return

        TransactionService.riskLevels()
            .then(
                response => {
                    if (response.data && response.data.success === true) {
                        const txRiskLevels = response.data.items

                        CommonService.saveTxRiskLevels(txRiskLevels)
                        this.props.commonAction(CHANGE_TX_RISK_LEVELS, txRiskLevels)
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    }
                }
            )
    }

    checkCustomerRiskLevels = () => {

        const customerRiskLevels = this.state.customerRiskLevels
        if (izNotEmpty(customerRiskLevels)) return

        CustomerService.riskLevels()
            .then(
                response => {
                    if (response.data && response.data.success === true) {
                        const customerRiskLevels = response.data.items

                        CommonService.saveCustomerRiskLevels(customerRiskLevels)
                        this.props.commonAction(CHANGE_CUSTOMER_RISK_LEVELS, customerRiskLevels)
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    }
                }
            )
    }

    izNotTxRiskLevelExist = (riskLevel) => {
        const txRiskLevels = this.props.common.txRiskLevels
        if (izEmpty(txRiskLevels)) return true;
        return izEmpty(txRiskLevels.filter(txRiskLevel => txRiskLevel.code === riskLevel))
    }

    izNotCustomerRiskLevelExist = (riskLevel) => {
        const customerRiskLevels = this.props.common.customerRiskLevels
        if (izEmpty(customerRiskLevels)) return true;
        return izEmpty(customerRiskLevels.filter(customerRiskLevel => customerRiskLevel.code === riskLevel))
    }

    search = () => {

        let {riskLevel, dateType, startDate, endDate, filterCriteria} = this.state;
        if (this.izNotTxRiskLevelExist(riskLevel)) {
            riskLevel = ''
        }

        if (dateType === 'range') {
            if (!startDate || startDate.trim() === "" || !endDate || endDate.trim() === "") {
                return message.error(i18n.t('error_date_range'))
            }
        }

        this.setState({searching: true})

        TransactionService.search(riskLevel, dateType, startDate, endDate, filterCriteria)
            .then(
                response => {

                    if (response.data.success === true) {
                        const items = response.data.items

                        setTimeout(function () {
                            this.setState({
                                searching: false,
                                items: items ? items : []
                            });
                        }.bind(this), 351);
                    } else {
                        this.setState({
                            searching: false,
                            items: []
                        })

                        if (response.data.error && response.data.error !== "") {
                            message.error(response.data.error)
                        } else {
                            message.error(i18n.t('global_error'))
                        }
                    }
                },
                error => {
                    this.setState({
                        searching: false,
                        items: []
                    })

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("TransactionService.search Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    handleRiskLevel = riskLevel => {
        this.setState({
            searching: false,
            riskLevel: riskLevel
        })

        setTimeout(function () {
            this.search();
        }.bind(this), 313);
    }

    handleDateType = dateType => {
        this.setState({
            dateType: dateType
        })

        if (dateType !== "range") {
            setTimeout(function () {
                this.search();
            }.bind(this), 313);
        }
    }

    handleRanges = dates => {

        let startDate = dates[0] ? moment(dates[0]).format("YYYY-MM-DD") : '';
        let endDate = dates[1] ? moment(dates[1]).format("YYYY-MM-DD") : '';

        this.setState({
            startDate: startDate,
            endDate: endDate
        })

        if (izNotBlank(startDate) && izNotBlank(endDate)) {
            setTimeout(function () {
                this.search();
            }.bind(this), 313);
        }
    }

    handleInputChange = (e) => {
        let {name, value} = e.target
        this.setState({
            [name]: value
        })
    }

    handleCriteriaAndSearch = () => {
        this.search()
    }

    getAntdLocale() {
        let lang = this.props.common.lang
        if (lang && lang === "tr") {
            let trLocale = require('moment/locale/tr');
            moment.updateLocale('tr', trLocale)
            return localeTR;
        } else {
            let enLocale = require('moment/locale/en-gb');
            moment.updateLocale('en', enLocale)
            return localeEN;
        }
    }

    render() {
        const {items, riskLevel, txRiskLevels, dateType, filterCriteria, searching} = this.state;

        return (
            <>
                <section className="ms-section pb-20">
                    <div className="container">
                        <div className="row mb-20 custom-ant-select-2 custom-ant-range">
                            <div className="col-3">

                                <Select
                                    className="custom-transaction-range"
                                    value={dateType}
                                    size="large"
                                    onChange={dateType => this.handleDateType(dateType)}
                                >
                                    <Option key="last_7_days" value="last_7_days">{i18n.t('last_7_days')}</Option>
                                    <Option key="last_15_days" value="last_15_days">{i18n.t('last_15_days')}</Option>
                                    <Option key="last_1_month" value="last_1_month">{i18n.t('last_1_month')}</Option>
                                    <Option key="last_3_month" value="last_3_month">{i18n.t('last_3_month')}</Option>
                                    <Option key="all_time" value="all_time">{i18n.t('all_time')}</Option>
                                    <Option key="range" value="range">{i18n.t('range')}</Option>
                                </Select>

                                {dateType === 'range' &&
                                    <RangePicker
                                        locale={this.getAntdLocale()}
                                        size="large"
                                        className=""
                                        onChange={this.handleRanges}
                                    />
                                }

                            </div>

                            <div className="col-3">
                                <Select
                                    className="transaction-search-risk-level"
                                    value={riskLevel}
                                    size="large"
                                    onChange={riskLevel => this.handleRiskLevel(riskLevel)}
                                >
                                    <Option key="all" value="all">{i18n.t('allTxRiskLevels')}</Option>
                                    {txRiskLevels
                                        .map((txRiskLevel) => {
                                                let {code, name} = txRiskLevel;

                                                return <Option key={code} value={code}>{name}</Option>
                                            }
                                        )
                                    }
                                </Select>
                            </div>

                            <div className="custom-ant-search">
                                <Search
                                    size="large"
                                    name="filterCriteria"
                                    value={filterCriteria}
                                    placeholder={i18n.t('filterCriteria')}
                                    onChange={this.handleInputChange}
                                    onSearch={this.handleCriteriaAndSearch}
                                    allowClear
                                    enterButton={i18n.t('search')}
                                />
                            </div>
                        </div>

                        <div className="row justify-content-center pb-25">
                            <div className="form-box-report transaction-search-result custom-box-shadow custom-card-border">

                                <Spin indicator={antIcon} spinning={searching}>
                                    {searching ?
                                        <>
                                            <div className="transaction-search-result-count">{i18n.t('searching')}</div>
                                        </>
                                        :
                                        <TransactionTable items={items} history={this.props.history}/>
                                    }
                                </Spin>

                            </div>
                        </div>

                    </div>
                </section>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionMonitoring);